import React, { forwardRef, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import { Controller } from "react-hook-form";
import EventController from "./../../pages/Admin/Controller/event_controller.ts";
import IndividualMembershipController from "../../pages/Admin/Controller/individual_membership_controller.ts";
import CorporateMembershipController from "../../pages/Admin/Controller/corporate_membership_controller.ts";
import DocumentController from "../../pages/Admin/Controller/document_controller.ts";

const SelectInput = forwardRef(
  (
    {
      type,
      onErrorCheck,
      control,
      name,
      onEmailCheck,
      getValues,
      onChange,
      ...props
    },
    ref
  ) => {
    const [eventCategoriesRow, setEventCategoriesRow] = useState([]);
    const [membertypeRow, setMemberTypeRow] = useState([]);
    const [resourcesTypeRow, setResourcesTypeRow] = useState([]);
    const [member_typeIDsRow, setMemberTypeIDs] = useState([]);
    const [committee_typeIDsRow, setCommitteeTypeIDs] = useState([]);
    const [committee_membersRow, setCommitteeMembers] = useState([]);
    const [secretariatRow, setSecretariat] = useState([]);
    const [event_categoryID, setEventCategoryID] = useState([]);
    const sex = [
      { value: "1", label: "Male" },
      { value: "0", label: "Female" },
    ];

    const designation = [
      { value: "0", label: "President" },
      { value: "1", label: "Secretary" },
    ];

    const maritalStatusOptions = [
      { value: "0", label: "Single" },
      { value: "1", label: "Married" },
      { value: "2", label: "Divorced" },
      { value: "3", label: "Widowed" },
      { value: "4", label: "Separated" },
    ];

    const academicQualification = [
      { value: 0, label: "None" },
      { value: 1, label: "Certificate" },
      { value: 2, label: "Diploma" },
      { value: 3, label: "Advanced Diploma" },
      { value: 4, label: "Bachelor" },
      { value: 5, label: "Masters" },
      { value: 6, label: "Doctoral" },
    ];

    const raceOptions = [
      { value: 0, label: "Malay" },
      { value: 1, label: "Chinese" },
      { value: 2, label: "Indian" },
      { value: 3, label: "Indigenous Peoples" },
      { value: 4, label: "Others" },
    ];

    const accountType = [
      { value: "0", label: "Appointed Rept. Account" },
      { value: "1", label: "Alternate Rept. Account" },
    ];

    const publishStatusOption = [
      { value: "1", label: "Publish" },
      { value: "0", label: "Unpublish" },
    ];

    const salutationOption = [
      { value: "0", label: "Mr" },
      { value: 1, label: "Mrs" },
      { value: 11, label: "Miss" },
      { value: 2, label: "Ms" },
      { value: 3, label: "Dato" },
      { value: 4, label: "Tan Sri" },
      { value: 5, label: "Puan Sri" },
      { value: 6, label: "Datuk Seri" },
      { value: 7, label: "Datin Seri" },
      { value: 8, label: "Datuk" },
      { value: 9, label: "Datin" },
      { value: 10, label: "Dr" },
    ];

    const publicSalutationOption = [
      { value: 0, label: "Mr" },
      { value: 2, label: "Ms" },
    ];

    const malaysianStatesOption = [
      { value: "Johor", label: "Johor" },
      { value: "Kedah", label: "Kedah" },
      { value: "Kelantan", label: "Kelantan" },
      { value: "Melaka", label: "Melaka" },
      { value: "Negeri Sembilan", label: "Negeri Sembilan" },
      { value: "Pahang", label: "Pahang" },
      { value: "Perak", label: "Perak" },
      { value: "Perlis", label: "Perlis" },
      { value: "Pulau Pinang", label: "Pulau Pinang" },
      { value: "Selangor", label: "Selangor" },
      { value: "Sabah", label: "Sabah" },
      { value: "Sarawak", label: "Sarawak" },
      { value: "WP-Labuan", label: "WP-Labuan" },
      { value: "WP-KL", label: "WP-KL" },
      { value: "WP-Putrajaya", label: "WP-Putrajaya" },
      { value: "Overseas", label: "Overseas"}
    ];

    const dietaryRestrictionOption = [
      { value: "Non-Vegetarian", label: "Non-Vegetarian" },
      { value: "Vegetarian", label: "Vegetarian" },
    ];

    const IndividualMembership = [
      { value: "MTYPE-000002", label: "Individual" },
      { value: "MTYPE-000005", label: "Affiliate Individual" },
      { value: "MTYPE-000003", label: "Associate" },
      // { value: "MTYPE-000006", label: "Honourary Member" },
    ];

    const CorporateMembership = [
      { value: "MTYPE-000001", label: "Corporate" },
      { value: "MTYPE-000004", label: "Affiliate Corporate" },
    ];

    const handleChange = (e) => {
      const newValue = e.target.value;
      console.log("Child onChange:", newValue); // Debug in child
      if (onChange) {
        onChange(newValue); // Pass to parent
      }
    };

    useEffect(() => {
      const fetchData = async () => {
        try {
          const eventCategories = await EventController.getEventCategories();
          if (Array.isArray(eventCategories)) {
            setEventCategoriesRow(
              eventCategories.map((item) => ({
                value: item.event_categoryID,
                label: item.event_category_name,
              }))
            );
          }

          const memberTypes =
            await IndividualMembershipController.getMemberType();
          setMemberTypeRow(
            memberTypes.map((item) => ({
              value: item.member_typeID,
              label: item.label,
            }))
          );

          const resourcesCategories =
            await DocumentController.getResourcesCategories();
          setResourcesTypeRow(
            resourcesCategories.map((item) => ({
              value: item.document_categoryID,
              label: item.label,
            }))
          );

          const member_typeIDs =
            await IndividualMembershipController.getMemberType();
          setMemberTypeIDs(
            member_typeIDs.map((item) => ({
              value: item.member_typeID,
              label: item.label,
            }))
          );

          const committeeTypes =
            await CorporateMembershipController.getCommitteeType();
          setCommitteeTypeIDs(
            committeeTypes.map((item) => ({
              value: item.committee_typeID,
              label: item.label,
            }))
          );

          // const committeeMembers =
          //   await EventController.getCommitteeRecipients();
          // setCommitteeMembers(
          //   committeeMembers.map((item) => ({
          //     value: item.userID,
          //     label: item.name,
          //   }))
          // );

          // const secretariatMembers =
          //   await CorporateMembershipController.getSecretariats();
          // setSecretariat(
          //   secretariatMembers.map((item) => ({
          //     value: item.committee_typeID,
          //     label: item.label,
          //   }))
          // );

          const event_categoryIDs = await EventController.getEventCategories();
          setEventCategoryID(
            event_categoryIDs.map((item) => ({
              value: item.event_categoryID,
              label: item.event_category_name,
            }))
          );
        } catch (error) {
          console.error("Error fetching select input data:", error);
        }
      };

      fetchData();
    }, []);

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          // console.log("Controller render value:", value); // Debug
          const handleChange = (e) => {
            const newValue = e.target.value;
            console.log("Controller onChange value:", newValue); // Debug
            field.onChange(newValue); // React Hook Form's onChange
          };
          return (
            <TextField
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  fontSize: "16px",
                  borderRadius: "25px",
                  color: "black",
                  backgroundColor: "white",
                  "& fieldset": {
                    borderColor: "#ccc",
                  },
                  "&:hover fieldset": {
                    borderColor: "#999",
                  },
                  // "&.Mui-focused fieldset": {
                  //   borderColor: "transparent",
                  //   outline: "none",
                  // },
                },
              }}
              select
              error={Boolean(onErrorCheck || error)}
              helperText={onErrorCheck || error?.message || ""}
              inputRef={ref}
              value={field.value || ""} // Ensure proper handling
              onChange={handleChange}
            >
              <MenuItem key="empty" value="">
                Select an option
              </MenuItem>
              {[
                "sex",
                "appointedRepresentativeSex",
                "alternateRepresentativeSex",
                "gender",
              ].includes(name)
                ? sex.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : [
                    "maritalStatus",
                    "appointedRepresentativeMaritalStatus",
                    "alternateRepresentativeMaritalStatus",
                    "marital_status",
                  ].includes(name)
                ? maritalStatusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : name === "eventCategory"
                ? eventCategoriesRow.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : name === "Designation"
                ? designation.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : [
                    "academicQualification",
                    "appointedRepresentativeAcademicQualification",
                    "alternateRepresentativeAcademicQualification",
                    "othersAcademicQualification",
                    "academic_qualification",
                  ].includes(name)
                ? academicQualification.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : name === "IndividualMembershipCategory"
                ? IndividualMembership.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : name === "CorporateMembershipCategory"
                ? CorporateMembership.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["resourcesCategories"].includes(name)
                ? resourcesTypeRow.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["member_typeIDs"].includes(name)
                ? member_typeIDsRow.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["committee_typeID"].includes(name) &&
                  committee_typeIDsRow.length > 0
                ? committee_typeIDsRow.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["committeeMembers"].includes(name) &&
                  committee_membersRow.length > 0
                ? committee_membersRow.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["type"].includes(name)
                ? accountType.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["race"].includes(name)
                ? raceOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["publish_status"].includes(name)
                ? publishStatusOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["event_categoryID"].includes(name)
                ? event_categoryID.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : [
                    "salutationOfContactPerson",
                    "othersSalutation",
                    "appointedRepresentativeSalutation",
                    "alternateRepresentativeSalutation",
                    "salutation",
                  ].includes(name)
                ? salutationOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["public_salutation", "contact_person_salutation"].includes(
                    name
                  )
                ? publicSalutationOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : [
                    "registeredAddressState",
                    "correspondenceAddressState",
                  ].includes(name)
                ? malaysianStatesOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : ["dietaryRestriction"].includes(name)
                ? dietaryRestrictionOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : null}
            </TextField>
          );
        }}
      />
    );
  }
);

SelectInput.propTypes = {
  type: PropTypes.string,
  onErrorCheck: PropTypes.string,
  onEmailCheck: PropTypes.func,
};

export default SelectInput;
